import { Skeleton } from '@mui/material';
import { Button } from 'Components/designSystem';
import { useTranslation } from 'react-i18next';
import { useTenantContext } from 'shared/contexts';
import { useAccessFilterCheck } from 'shared/hooks';

import { useCandidateAuth } from '../../AuthProvider';
import AvatarWithTenants from './AvatarWithTenants';

export default function UserWidget() {
    const { t } = useTranslation('auth');
    const { login, logout, user, isAuthenticated, availableTenants, status, changeTenant, currentCandidateEmail } = useCandidateAuth();
    const authEnabled = useAccessFilterCheck({ feature: 'CandidateRole' });
    const tenant = useTenantContext();

    if (!authEnabled || !currentCandidateEmail) {
        return null;
    }

    if (status === 'pendingSilent') {
        return <Skeleton variant="circular"
            width={ 32 }
            height={ 32 }
        />;
    }

    if (isAuthenticated && user) {
        return (
            <AvatarWithTenants onLogout={ logout }
                user={ user }
                availableTenants={ availableTenants }
                onTenantChange={ changeTenant }
                selectedTenant={ tenant } />
        );
    }

    return (
        <Button onClick={ () => login() }
            label={ t('login') }
            isLoading={ status === 'pending' }
            color="secondary" />
    );
}
